import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useGetFileUrl } from '../../../hooks/useGetFileUrl'

const textOverlayStyle = {
  color: '#000',
  fontSize: { md: '17px', sm: '12px', xs: '6px' },
  fontWeight: 'bold',
  position: 'absolute',
}

const RecordCheckCertificateViewer = ({ generatePDF, templateImage, user }) => {
  const { t } = useTranslation()
  const profileAvatarUrl = useGetFileUrl(user.profile_picture)
  const [isTemplateLoaded, setIsTemplateLoaded] = useState(false)
  const [existData, setExistData] = useState(false)
  const [missingData, setMissingData] = useState([])

  useEffect(() => {
    const missingFields = Object.entries(user)
      .filter(
        ([key, value]) =>
          key === null || value === '' || value === null || value === undefined
      )
      .map(([key]) => key)
    setMissingData(missingFields)
    setExistData(missingFields.length === 0)
  }, [user])

  const photoProfile = useMemo(
    () =>
      profileAvatarUrl
        ? `${import.meta.env.VITE_CLOUDFRONT_DISTRIBUTION_URL}${profileAvatarUrl}`
        : '',
    [profileAvatarUrl]
  )
  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: '800px',
        textAlign: 'center',
        width: '100%',
      }}
    >
      {existData ? (
        <Box
          id="certificate"
          sx={{
            aspectRatio: '16 / 9',
            border: '1px solid #ddd',
            overflow: 'hidden',
            position: 'relative',
            width: '100%',
          }}
        >
          {!isTemplateLoaded && (
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minHeight: '50vh',
                zIndex: 20,
              }}
            >
              <CircularProgress />
              <Typography sx={{ mt: 2 }}>{t('general.loading')}...</Typography>
            </Box>
          )}
          <img
            alt="Certificate Template"
            crossOrigin="anonymous"
            onError={() => setIsTemplateLoaded(true)}
            onLoad={() => setIsTemplateLoaded(true)}
            src={templateImage}
            style={{
              height: '100%',
              left: 0,
              position: 'absolute',
              top: 0,
              width: '100%',
              zIndex: 0,
            }}
          />
          {isTemplateLoaded && (
            <>
              <img
                alt="Profile"
                src={photoProfile}
                style={{
                  background: 'white',
                  border: '3px solid white',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  left: '5%',
                  position: 'absolute',
                  top: '25%',
                  width: '22%',
                  zIndex: 20,
                }}
              />
              <Box sx={{ ...textOverlayStyle, left: '50%', top: '30%' }}>
                {user.full_name}
              </Box>
              <Box sx={{ ...textOverlayStyle, left: '55%', top: '60%' }}>
                {user.expiration_date}
              </Box>
              <Box sx={{ ...textOverlayStyle, left: '35%', top: '69%' }}>
                {user.vehicle.make?.name}
              </Box>
              <Box sx={{ ...textOverlayStyle, left: '35%', top: '74%' }}>
                {user.vehicle.model?.name}
              </Box>
              <Box sx={{ ...textOverlayStyle, left: '67%', top: '74%' }}>
                {user.vehicle.year}
              </Box>
              <Box sx={{ ...textOverlayStyle, left: '50%', top: '78%' }}>
                {user.vehicle.plate_number}
              </Box>
            </>
          )}
        </Box>
      ) : (
        <Typography>
          {t('documents.validations.no_data')}
          {missingData.map((field, index) => (
            <Typography key={index} style={{ display: 'block' }}>
              • {field}
            </Typography>
          ))}
        </Typography>
      )}
      {isTemplateLoaded && (
        <Button
          onClick={generatePDF}
          sx={{
            '&:hover': {
              background: 'darkblue',
            },
            background: 'blue',
            color: 'white',
            marginTop: '20px',
            padding: '10px 20px',
          }}
        >
          {t('common.download')} PDF
        </Button>
      )}
    </Box>
  )
}

export default RecordCheckCertificateViewer
